import { Injectable } from '@angular/core';
import { Api, User } from '../'

@Injectable()
export class Task {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) {
    return this.api.get('index.php/marketing/task', params);
  }

  delete(params?: any) {
    return this.api.post('index.php/marketing/task/delete', params);
  }

  post(params?: any) {
    if(params.id==''){
      params.created_by = this.user.data.employee_id;
    }else{
      params.updated_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/marketing/task', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/marketing/task/task.ts